"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cohortAvailable = void 0;
exports.cohortSeries = cohortSeries;
const chart_compare_1 = require("./chart-compare");
/**
 * The development view is offered for a single comparison by Jahrgang
 * (no second dimension; the double comparison keeps its panels).
 */
const cohortAvailable = (compare) => !!compare && compare.by === "birthYear" && !compare.by2;
exports.cohortAvailable = cohortAvailable;
/**
 * One series per Jahrgang (in compare order) with one point per timepoint
 * key of the comparison. A point is a gap when the timepoint or the single
 * mean is hidden, or when the cohort has no value there.
 */
function cohortSeries(compare, feature) {
    if (!(0, exports.cohortAvailable)(compare))
        return [];
    const keys = Array.from(new Set(compare.groups.flatMap((g) => g.timepoints.map((t) => t.key)))).sort((a, b) => Number(a.slice(1)) - Number(b.slice(1)));
    return compare.groups.flatMap((g) => {
        const year = (0, chart_compare_1.birthYearOfKey)(g.key);
        if (year === null)
            return [];
        const points = keys.map((key) => {
            const tp = g.timepoints.find((t) => t.key === key);
            const hidden = !!tp && (tp.suppressed || tp.meanN[feature] === null);
            return {
                key,
                value: !tp || hidden ? null : tp.means[feature],
                n: !tp || hidden ? null : tp.meanN[feature],
                suppressed: hidden,
                dateMean: tp && !tp.suppressed ? tp.dateMean : null,
            };
        });
        return [{ key: g.key, year, points }];
    });
}
